<template>
  <badge :type="getBadgeType()">{{
    statusesOptions[resellerPayment.status]
  }}</badge>
</template>

<script>
import {
  paymentStatusesOption,
  PAYMENT_STATUS_CANCELED,
  PAYMENT_STATUS_COMPLETED,
  PAYMENT_STATUS_DRAFT,
} from "@/constants/payments";

export default {
  name: "reseller-payment-status-badge",

  components: {},

  mixins: [],

  props: ["resellerPayment"],

  data() {
    return {
      statusesOptions: paymentStatusesOption,
    };
  },

  computed: {},

  methods: {
    getBadgeType() {
      switch (this.resellerPayment.status) {
        case PAYMENT_STATUS_DRAFT:
          return "primary";
        case PAYMENT_STATUS_COMPLETED:
          return "success";
        case PAYMENT_STATUS_CANCELED:
          return "danger";
        default:
          break;
      }
      return "default";
    },
  },

  mounted() {},

  watch: {},
};
</script>
